import { AJAX_PUBLIC_REQUEST } from '../../Constants/AppConstants';

export function passwordResetRequest(userData) {
    return dispatch => {
        return AJAX_PUBLIC_REQUEST("POST", "user/forgotPassword", userData);
    }
}